import { MotionMapperType, GLBMotionMapper, GLBAnimationType } from "../models/Model";
import { ModelLoader } from "../panels/common/ModelLoader";
import { BaseAnimator } from "./BaseAnimator";
import * as THREE from "three";

export class GLBAnimator extends BaseAnimator {
  mapper: GLBMotionMapper;
  mixer: THREE.AnimationMixer;
  modelObj: THREE.Object3D<THREE.Object3DEventMap>;
  animations: THREE.AnimationClip[] = [];
  constructor(public modelLoader: ModelLoader) {
    super();
    this.modelObj = modelLoader.modelObj!;
    this.mapper = modelLoader.model.motionMapper as GLBMotionMapper;
    this.mixer = new THREE.AnimationMixer(this.modelObj);
    this.mixer.addEventListener("finished", (event) => {
    });
    const gltf = this.modelObj.userData.gltf;
    this.animations = gltf ? gltf.animations : [];
    const setupAnim = this.findAnimationForType(GLBAnimationType.Setup);
    if (setupAnim) {
      this.startAnimation(setupAnim, true);
    }
    const idleAnim = this.findAnimationForType(GLBAnimationType.Idle);
    if (idleAnim) {
      this.startAnimation(idleAnim);
    }

    // this.walk();
  }

  public walk() {
    const walkAnim = this.findAnimationForType(GLBAnimationType.Walk);
    if (walkAnim) {
      this.startAnimation(walkAnim);
    }
  }

  private findAnimationForType(type: GLBAnimationType): string | undefined {
    return Object.keys(this.mapper.animationMap).find((key) => this.mapper.animationMap[key] === type);
  }

  public startAnimation(animationName: string, setup = false) {
    const clip = this.animations.find((a: any) => a.name === animationName);
    if (clip) {
      this.mixer.stopAllAction();
      const action = this.mixer.clipAction(clip);
      if (setup) {
        action.loop = THREE.LoopOnce;
        action.clampWhenFinished = true;
      }
      action.play();
      this.mixer.update(0);
    }
  }

  public stop() {
    this.mixer.stopAllAction();
    const idleAnim = this.findAnimationForType(GLBAnimationType.Idle);
    if (idleAnim) {
      this.startAnimation(idleAnim);
    }
  }

  public render(delta: number): void {
    // this.modelObj.children[0].updateMatrixWorld(); // Ensure the model's world matrix is updated
    this.mixer.update(delta);
  }
}